const pullListLabels = {
    id: "id",
    epId: "Experimental Plan",
    pullListId: "Pull List",
    version: "Version",
    boxId: "Box ID",
    pullListFile: "Pull List File",
    pullListFileVersion: "Pull List File Version",
    sampleQualityFile: "Sample Quality Checklist",
    sampleQualityFileVersion: "Sample Quality Checklist Version",
    disposalRequestFile: "Disposal Request Documentation",
    disposalRequestFileVersion: "Disposal Request Documentation Version",
    status: "Workflow Status",
    shipmentFromRepo: "Shipment from Repository",
    rushOrder: "Rush Order",
    disposalReason: "Disposal Reason",
    pullListComment: "Pull List Comments",
    numberOfSamples: "Total Number of Samples",
    shippingTemperature: "Shipping Temperature",
    dispositionOfSample: "Planned Final Disposition of Samples",
    informedConsent: "Informed Consent verification completed?",
    informedConsentApprover: "Informed Consent verification completed?",
    informedConsentComment: "Informed Consent Comments",
    disposalRequest: "Disposal Request verified?",
    disposalRequestApprover: "Disposal Request verified?",
    disposalRequestComment: "Disposal Request Comments",
    approvalBy: "Approved By",
    approvalDate: "Approval Date",
    courier: "Courier",
    trackingNumber: "Tracking Number(s)",
    serviceRequestNumber: "Service Request Number(s)",
    submitDate: "Date Submitted",
    shipDate: "Ship Date",
    disposalDate: "Disposal Date",
    labName: "Lab Name",
    labDesc: "Lab Description",
    labContact: "Contact",
    labPhoneNumber: "Phone Number",
    labEmail: "Email Address",
    labPI: "PI",
    labAddress1: "Shipping Address 1",
    labAddress2: "Shipping Address 2",
    labAddress3: "Shipping Address 3",
    labAddress4: "Shipping Address 4",
    labCity: "Shipping City",
    labState: "Shipping State",
    labPostalCode: "Shipping Postal Code",
    labLegacyAddress: "Legacy Lab Address",
    expectedDataDate: "Expected Data Transfer to ITN",
    expectedCompletionDate: "Expected Completion Date",
    resultsReceivedDate: "Results Received Date",
    completionDate: "Completion Date",
    resultsValidatedDate: "Results Validated Date",
    validationStatus: "Validation Status",
    validationBy: "Validation By",
    validationNotesText: "Validation Notes",
    datasetsValidationLink: "Link to datasets & validation notes",
    relatedJiraTickets: "Jira ticket number(s) or link(s)",
    epUpdate: "EP Update",
};

export default pullListLabels;